// Sprint 6 — Hardware shop schemas.
//
// Single source of truth for the wire contract between backend (route
// validation) and mobile (typed API client).
import { z } from 'zod';
/** SKU enumeration. Adding a new SKU requires both updating the enum
 *  here AND wiring a new STRIPE_PRICE_<SKU> env var in the backend
 *  catalog. The mobile screen is data-driven from `/shop/products`, so
 *  adding a SKU doesn't require a mobile release.
 *
 *  Phase 25 iter-15 — DONGLE_BLE dropped per scope decision 2026-05-17
 *  (qualified eIDAS via BLE dongle is no longer part of the product). */
export const HardwareSkuSchema = z.enum(['KIT_10', 'KIT_50']);
export const ShopProductSchema = z.object({
    sku: HardwareSkuSchema,
    label: z.string(),
    description: z.string(),
    /** Price in EUR cents (e.g. 4900 for 49 €). Render with `cents/100`. */
    amount_cents: z.number().int().nonnegative(),
    currency: z.string(),
    /** True when this SKU has a configured Stripe Price and can be ordered. */
    available: z.boolean(),
});
export const ShopProductsResponseSchema = z.object({
    products: z.array(ShopProductSchema),
});
export const ShopCheckoutRequestSchema = z.object({
    sku: HardwareSkuSchema,
    /** Quantity 1-10. Larger orders should go through cooperatives manually. */
    quantity: z.number().int().min(1).max(10).default(1),
});
export const HardwareOrderStatusSchema = z.enum([
    'PENDING_FULFILLMENT',
    'SHIPPED',
    'DELIVERED',
    'CANCELLED',
]);
export const HardwareOrderSchema = z.object({
    id: z.string(),
    product_sku: HardwareSkuSchema,
    product_label: z.string(),
    amount_cents: z.number().int(),
    currency: z.string(),
    status: HardwareOrderStatusSchema,
    tracking_number: z.string().nullable(),
    created_at: z.string().datetime(),
    shipped_at: z.string().datetime().nullable(),
});
export const HardwareOrdersListResponseSchema = z.object({
    orders: z.array(HardwareOrderSchema),
});
//# sourceMappingURL=shop.js.map